import { all, call, fork, put, takeEvery } from 'redux-saga/effects'
import * as Actions from './actions'
import { callApi } from '../../utils/callApi'
import { API_ROUTES } from '../../utils/apiRoutes'
import { ActionTypes } from './types'


function* getCurrentTimeWorker(action: ReturnType<typeof Actions.GetCurrentTime.request>) {
  const { callBack } = action.payload as Actions.TypeGetCurrentTimeR
  let success = true
  let data = null
  
  try {
    data = (yield call(callApi, {
      method: 'get',
      path: API_ROUTES.currentTime,
    })) as string
    
    yield put(Actions.GetCurrentTime.success(data))
  } catch (e) {
    success = false
    // @ts-ignore
    data = e?.data || e
    yield put(Actions.GetCurrentTime.error(`${data?.message || data}`))
  } finally {
    if (callBack) callBack(success, data)
  }
}


function* watchRequest() {
  yield takeEvery(ActionTypes.GET_CURRENT_TIME_R, getCurrentTimeWorker)
}

export default function* currentTimeSaga() {
  yield all([fork(watchRequest)])
}
